
    import {Options, Prop, Vue} from 'vue-property-decorator';
    import {Tag} from '@/profile-creation-wizard/components/for-creation/Tag';

    @Options({})
    export default class SelectedTags extends Vue {
        @Prop({type: Array})
        tags!: Tag[];

        handlerRemove(event: CustomEvent) {
            this.$emit('remove', {name: event.detail});
        }
    }
